import React from 'react';

const PopupContent = ({children}) => (
  <div className="popup__content">
    {children}
  </div>
);

export default PopupContent;
